import React from 'react';
import EditButton from '../../ui/EditButton';
import { normalizeTeamMetadata } from '../utils/teamMetadata';
import { EMPTY_VALUE_LABEL } from '../../../utils/formFieldPresentation';

function formatList(values = []) {
  return values.length > 0 ? values.join(', ') : EMPTY_VALUE_LABEL;
}

export default function MetadataCard({ name = '', description = '', metadata = {}, onEdit }) {
  const normalizedMetadata = normalizeTeamMetadata(metadata);
  const { ageGroup, ageRestrictions = {}, justification } = metadata;

  const renderAgeRestriction = () => {
    const { min, max } = ageRestrictions;
    if (!min && !max) return 'None';
    if (min && max) return `Ages ${min}–${max}`;
    if (min) return `Ages ${min}+`;
    return `Up to age ${max}`;
  };

  return (
    <div className="team-card">
      <div className="card-header-with-icon">
        <span className="card-title">Club Details</span>
        <EditButton section="teamMetadata" onEdit={onEdit} />
      </div>
      <div className="card-body">
        <div className="join-link-container" style={{ marginBottom: '1rem' }}>
          <p className="join-link-label" style={{ fontWeight: 500 }}>Club Name</p>
          <div
            style={{
              background: '#f5f5f5',
              padding: '0.5rem',
              borderRadius: '4px',
              fontSize: '0.875rem',
              lineHeight: 1.4,
            }}
          >
            {name || EMPTY_VALUE_LABEL}
          </div>
        </div>

        <div className="join-link-container" style={{ marginBottom: '1rem' }}>
          <p className="join-link-label" style={{ fontWeight: 500 }}>Public Description</p>
          <div
            style={{
              background: '#f5f5f5',
              padding: '0.5rem',
              borderRadius: '4px',
              fontSize: '0.875rem',
              lineHeight: 1.4,
            }}
          >
            {description || EMPTY_VALUE_LABEL}
          </div>
        </div>

        <ul className="availability-status-list">
          <li className="availability-status-item">
            <div className="availability-status-label">
              <span className="availability-status-icon">🏷️</span>
              <span>Primary Label</span>
            </div>
            <span className="availability-pill available">{normalizedMetadata.primaryLabel || EMPTY_VALUE_LABEL}</span>
          </li>

          <li className="availability-status-item">
            <div className="availability-status-label">
              <span className="availability-status-icon">🗂️</span>
              <span>Categories</span>
            </div>
            <span className="availability-pill available">{formatList(normalizedMetadata.categories)}</span>
          </li>

          <li className="availability-status-item">
            <div className="availability-status-label">
              <span className="availability-status-icon">🏅</span>
              <span>Types</span>
            </div>
            <span className="availability-pill available">{formatList(normalizedMetadata.types)}</span>
          </li>

          <li className="availability-status-item">
            <div className="availability-status-label">
              <span className="availability-status-icon">👥</span>
              <span>Age Group</span>
            </div>
            <span className="availability-pill available">{ageGroup || EMPTY_VALUE_LABEL}</span>
          </li>

          <li className="availability-status-item">
            <div className="availability-status-label">
              <span className="availability-status-icon">📏</span>
              <span>Age Restriction</span>
            </div>
            <span className="availability-pill available">{renderAgeRestriction()}</span>
          </li>
        </ul>

        {justification && (
          <div className="join-link-container" style={{ marginTop: '1rem' }}>
            <p className="join-link-label" style={{ fontWeight: 500 }}>Justification:</p>
            <div
              style={{
                background: '#f5f5f5',
                padding: '0.5rem',
                borderRadius: '4px',
                fontSize: '0.875rem',
                lineHeight: 1.4,
              }}
            >
              {justification}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
